import React, { useEffect, useState } from "react";

import Editor, {
  BtnBold,
  BtnItalic,
  BtnNumberedList,
  BtnBulletList,
  BtnUnderline,
  Separator,
  HtmlButton,
  EditorProvider,
  Toolbar
} from "react-simple-wysiwyg";

interface RichTextEditorProps {
  initialContent?: string;
  placeholder?: string;
  onChange: (content: string) => void;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  initialContent = "",
  onChange,
  placeholder = "",
}) => {
  const [content, setContent] = useState(initialContent);

  useEffect(() => {
    // Sempre limpa o conteúdo inicial
    setContent(initialContent);
  }, [initialContent]);

  const handleChange = (event: { target: { value: string } }) => {
    const value = event.target.value;
    setContent(value);
    onChange(value);
  };

  return (
    <EditorProvider>
      <Editor value={content} placeholder={placeholder ?? "Digite o seu texto ..."} onChange={handleChange} containerProps={{ style: { resize: 'vertical' } }} style={{ background: "#fff", color: "#000", height: 300 }}>
        <Toolbar>
          <BtnBold />
          <BtnItalic />
          <BtnUnderline />
          <Separator />
          <BtnNumberedList />
          <BtnBulletList />
          <Separator />
        {/*   <BtnStrikeThrough />
          <BtnClearFormatting /> */}
          <HtmlButton />
        </Toolbar>
      </Editor>
    </EditorProvider>

  );
};

export default RichTextEditor;
